import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h1>Sorry! This page not available</h1>
        </div>
    );
};

export default NotFound;